import {
    useEffect,
    useState
} from 'react';

import {

    getShorts,

    insertShorts,

    updateShortsTitle,

    deleteShorts

} from '../../../api/adminApi';

import './AppShortsManage.css';

interface Shorts {

    id: number;

    title: string;

    imageUrl: string;

    youtubeUrl: string;
}

const AppShortsManage = () => {

    const [list, setList] =
        useState<Shorts[]>([]);

    const [youtubeUrl, setYoutubeUrl] =
        useState('');

    const [showModal, setShowModal] =
        useState(false);

    const [editItem, setEditItem] =
        useState<Shorts | null>(null);

    useEffect(() => {

        loadData();

    }, []);

    const loadData = async () => {

        const res =
            await getShorts();

        setList(
            res.data
        );
    };

    const handleInsert =
        async () => {

            if(
                !youtubeUrl
            ) {

                return;
            }

            await insertShorts(
                youtubeUrl
            );

            setYoutubeUrl('');

            loadData();
        };

    const handleDelete =
        async (
            id: number
        ) => {

            if(
                !window.confirm(
                    '삭제하시겠습니까?'
                )
            ) {

                return;
            }

            await deleteShorts(
                id
            );

            loadData();
        };

    const handleSave =
        async () => {

            if(
                !editItem
            ) {

                return;
            }

            await updateShortsTitle(

                editItem.id,

                editItem.title

            );

            setShowModal(false);

            loadData();
        };

    return (

        <div
            className="shorts-manage"
        >

            <h2>
                쇼츠 관리
            </h2>

            <div
                className="shorts-form"
            >

                <input

                    value={
                        youtubeUrl
                    }

                    placeholder=
                        "유튜브 URL"

                    onChange={(e) =>

                        setYoutubeUrl(
                            e.target.value
                        )
                    }
                />

                <button
                    onClick={
                        handleInsert
                    }
                >
                    등록
                </button>

            </div>

            <div
                className="shorts-list"
            >

                {
                    list.map(item => (

                        <div

                            key={item.id}

                            className=
                                "shorts-card"
                        >

                            <img
                                src={
                                    item.imageUrl
                                }
                                alt=""
                            />

                            <div
                                className=
                                    "shorts-info"
                            >

                                <h4>
                                    {item.title}
                                </h4>

                                <div
                                    className=
                                        "shorts-actions"
                                >

                                    <button

                                        className=
                                            "edit-btn"

                                        onClick={() => {

                                            setEditItem(
                                                item
                                            );

                                            setShowModal(
                                                true
                                            );

                                        }}
                                    >
                                        수정
                                    </button>

                                    <a

                                        href={
                                            item.youtubeUrl
                                        }

                                        target="_blank"

                                        rel="noreferrer"

                                        className=
                                            "video-btn"
                                    >
                                        영상 보기
                                    </a>

                                    <button

                                        className=
                                            "delete-btn"

                                        onClick={() =>
                                            handleDelete(
                                                item.id
                                            )
                                        }
                                    >
                                        삭제
                                    </button>

                                </div>

                            </div>

                        </div>

                    ))
                }

            </div>

            {
                showModal
                && editItem && (

                    <div
                        className=
                            "modal-overlay"
                    >

                        <div
                            className=
                                "modal-box"
                        >

                            <h3>
                                제목 수정
                            </h3>

                            <input

                                value={
                                    editItem.title
                                }

                                onChange={(e) =>

                                    setEditItem({

                                        ...editItem,

                                        title:
                                        e.target.value

                                    })
                                }
                            />

                            <div
                                className=
                                    "modal-buttons"
                            >

                                <button

                                    className=
                                        "edit-btn"

                                    onClick={
                                        handleSave
                                    }
                                >
                                    저장
                                </button>

                                <button

                                    className=
                                        "delete-btn"

                                    onClick={() =>

                                        setShowModal(
                                            false
                                        )
                                    }
                                >
                                    취소
                                </button>

                            </div>

                        </div>

                    </div>

                )
            }

        </div>
    );
};

export default AppShortsManage;